// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module__container___wQoS_","uuid":"index-module__uuid___1T3aJ"};